// pages/auth/Register.js
import React, { useState } from 'react';
import api from '../../services/api';

function Register() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async () => {
    try {
      const res = await api.post('/auth/register', { email });
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error');
    }
  };

  return (
    <div className="page-container">
      <h2>Register</h2>
      <div className="form-group">
        <label>Email</label>
        <input 
          type="email" 
          value={email}
          placeholder="Enter your email" 
          onChange={(e) => setEmail(e.target.value)} 
        />
      </div>
      <button className="btn" onClick={handleRegister}>Register</button>
      {message && <p className="mt-1">{message}</p>}
    </div>
  );
}

export default Register;